import React, {useEffect, useState} from "react";
import {firestore} from "../firebase";
import {useAuth} from "../contexts/AuthContext"
import {useGroup} from "../contexts/GroupContext";
import Chat from "../components/ChatComponent";
import GoalComponent from "../components/GoalComponent";
import LoadingComponent from "./LoadingComponent";
import MapComponent from "../components/MapComponent";
import ButtonComponent from "../components/ButtonComponent";
import SettingsComponent from "../components/SettingsComponent";
import {Box, Grid, Paper} from "@mui/material";
import Typography from "@mui/material/Typography";

function HomeComponent() {

    //State
    const [isReady, setIsReady] = useState(false)
    const [instructions, setInstructions] = useState(false)
    const [rawData, setRawData] = useState()
    const {currentUser} = useAuth()
    const {group, name} = useGroup()

    useEffect(() => {
        //constructor
        if (currentUser !== undefined && group !== undefined && name !== undefined) {

            //Fetches the robot collections based on the user's group
            const fetchRobots = async (group) => {
                const col = await firestore.collection(`groups/${group}/robots`).get()
                const size = col.size
                if (size > 0) {
                    return col
                } else {
                    setInstructions(true)
                }
            }

            fetchRobots(group).then(r => {
                setRawData(r) //Nested collections means that later functions MUST be firebase specific.
            })
        }
    }, [currentUser, group, name])

    //If all the data is set, we're ready to render
    useEffect(() => {
        if (rawData !== undefined && rawData.docs !== undefined) {
            setIsReady(true)
        }
    }, [rawData])

    if (instructions) {
        return (
            <Box>
                <Paper>
                    <Box py={40} px={20}>
                        <Typography variant="h1">Initialization Required</Typography>
                        <Typography variant="body1">To use the Zeeno Control Center for the first time, please turn on your Temi and log in.</Typography>
                    </Box>
                </Paper>
            </Box>
        )
    }
    if (isReady) {
        return (
            <Box>
                <Grid container spacing={2}>
                    <Grid container item spacing={2} lg={12} xs={12}>
                        <Grid item xs={12}>
                            <GoalComponent rawData={rawData.docs}/>
                        </Grid>
                        <Grid item xs={12}>
                            <Chat/>
                        </Grid>
                        <Grid item xs={12}>
                            <ButtonComponent/>
                        </Grid>
                        <Grid item xs={12}>
                            <MapComponent/>
                        </Grid>
                        <Grid item xs={12}>
                            <SettingsComponent/>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        )
    } else {
        return (
            <LoadingComponent/>
        )
    }
}

export default HomeComponent;
